import { render, staticRenderFns } from "./ProjectMapIndex.vue?vue&type=template&id=2ed8efe4&scoped=true&"
import script from "./ProjectMapIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectMapIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMapIndex.vue?vue&type=style&index=0&id=2ed8efe4&prod&lang=less&scoped=true&"
import style1 from "./ProjectMapIndex.vue?vue&type=style&index=1&id=2ed8efe4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8efe4",
  null
  
)

export default component.exports